import React from "react";
import { Platform, View, Text, Linking, Alert } from "react-native";
//import RNIap from "react-native-iap";

import { navigate } from "../../../helpers/utils";
import AppTheme from "../AppTheme";
import ManaButton from "../common/ManaButton";
import Header from "../common/header/index";
import appStyles from '../../appStyles';
import appPages from "../../../appPages";

class PaymentsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.controller = props.controller;
  }

  render() {
    const purchase = this.controller.getPurchase();
    console.log(purchase);

    const subscription = purchase != null ? purchase.title : "none";
    const startDate =
      purchase != null ? new Date(purchase.transactionDate) : null;
    var endDate = null;
    if (purchase != null) {
      if (purchase.subscriptionPeriodUnitIOS === "YEAR") {
        endDate = new Date(
          startDate.getFullYear() + 1,
          startDate.getMonth(),
          startDate.getDate(),
        );
      } else if (purchase.subscriptionPeriodUnitIOS === "MONTH") {
        endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + 1);
        if (endDate.getDate() != startDate.getDate()) {
          endDate.setDate(0);
        }
      }
    }
    const purchaseDate =
      startDate != null ? startDate.toISOString().substring(0, 10) : null;
    const expiryDate =
      endDate != null ? endDate.toISOString().substring(0, 10) : null;
    const hasSubscription = purchase != null;

    const color = AppTheme.DEFAULT_COLOR;

    return (
      <View style={appStyles.container}>
        <Header
          title="Payment Settings"
          controller={this.controller}
          hideAvatar
          goBack={() => this.controller.goBack()}
        />
        <View
          style={{ alignItems: "center", justifyContent: "center", flex: 1 }}
        >
          <Text
            style={{ color }}
            onPress={() => Linking.openURL("https://mana.ai/terms-of-service")}
          >
            Terms Of Service
          </Text>
          <Text> </Text>
          <Text
            style={{ color }}
            onPress={() => Linking.openURL("https://mana.ai/privacy-policy")}
          >
            Privacy Policy
          </Text>
          <Text> </Text>
          <Text> </Text>
          <Text>Current: {subscription}</Text>
          {purchaseDate != null ? <Text>Purchased {purchaseDate}</Text> : null}
          {expiryDate != null ? <Text>Expires {expiryDate}</Text> : null}
          <Text> </Text>
          <ManaButton
            isMainButton
            onPress={() => this.onSubscriptions()}
            text={"View Subscriptions"}
          />
          <Text> </Text>
          <ManaButton
            isMainButton
            onPress={() => this.restorePurchases()}
            text={"Restore Purchases"}
          />
          <Text> </Text>
          <Text> </Text>
          <Text> </Text>
          {!hasSubscription ? <Text>Subscriptions offer access to</Text> : null}
          {!hasSubscription ? (
            <Text>full reflection and resolution functionality, </Text>
          ) : null}
          {!hasSubscription ? (
            <Text>as well as personalized interactions with our Guides</Text>
          ) : null}
          <Text> </Text>
          {!hasSubscription ? <Text>Mana Monthly Subscription</Text> : null}
          {!hasSubscription ? (
            <Text>1 month auto-renewing subscription, $19.99</Text>
          ) : null}
          {!hasSubscription ? (
            <ManaButton
              isMainButton
              onPress={() =>
                this.doSubscription("mana.ai.hours.subscription.monthly")
              }
              text={"Subscribe Monthly"}
            />
          ) : null}
          <Text> </Text>
          {!hasSubscription ? <Text>Mana Yearly Subscription</Text> : null}
          {!hasSubscription ? (
            <Text>1 year auto-renewing subscription, $199.99</Text>
          ) : null}
          {!hasSubscription ? (
            <ManaButton
              isMainButton
              onPress={() =>
                this.doSubscription("mana.ai.hours.subscription.yearly")
              }
              text={"Subscribe Yearly"}
            />
          ) : null}
          <Text> </Text>
          <Text> </Text>
          <Text> </Text>
          <ManaButton
            isMainButton
            onPress={() => this.onBack()}
            text={"Back"}
          />
        </View>
      </View>
    );
  }

  doSubscription(id) {
    //this.controller.paymentsIntegration.showPay();
    this.requestSubscription(id);
  }

  requestSubscription = async (sku) => {
    try {
      //await RNIap.requestSubscription(sku);
    } catch (err) {
      console.warn(err.code, err.message);
    }
  };

  onSubscriptions() {
    if (Platform.Version >= "12") {
      Linking.openURL("https://apps.apple.com/account/subscriptions");
    } else {
      Linking.openURL(
        "https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/manageSubscriptions",
      );
    }
  }

  restorePurchases = async () => {
    try {
      const purchases = []; //await RNIap.getAvailablePurchases();
      const newState = { subscription: "none" };
      let restoredTitles = [];

      purchases.forEach((purchase) => {
        switch (purchase.productId) {
          case "ai.mana.hours.tier1":
            newState.subscription = "tier1";
            restoredTitles.push("Subscription");
            break;
        }
      });

      if (restoredTitles.length == 0) {
        Alert.alert("Restore Purchases", "No purchases to restore");
      } else {
        Alert.alert(
          "Restore Purchases",
          "Successfully restored the following purchases: " +
            restoredTitles.join(", "),
        );
      }
    } catch (err) {
      console.warn(err); // standardized err.code and err.message available
      Alert.alert(err.message);
    }
  };

  onBack() {
    const screen = "feed";
    if (false) {
      //change page after requesting data
      const page = appPages.reflectionPage;
      const action = {
        action: "requestpage",
        page: page,
        page_args: {},
      };
      this.controller.getItemsBulk(action, screen, page, {});
    } else {
      navigate(this.controller, "rn:home_card");
    }
  }
}

export default PaymentsPage;
